import React, { useEffect, useState } from "react";
import { KeyboardAvoidingView, View, FlatList } from "react-native";

import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import Header from "../../common/header/index";
import ShareElementFabButton from "../share/ShareElementFabButton";
import BottomButton from "../../common/BottomButton";
import Search from "../../common/search-bar/Search";
import Utils, { escapeRegexp, hasItems } from "../../../../helpers/utils";
import ElementUser from "./ElementUser";
import UsersHelper from "../../users/UsersHelper";

export default function ElementsUsersList({
  onSelectionDone,
  controller,
  initialSelection = null,
}) {
  const [userList, setUserList] = useState([]);
  const [allUserList, setAllUserList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState(null);

  useEffect(() => {
    const users = UsersHelper.getShareUsers(controller);

    let usersList = [...users];
    let selected = [];
    if (initialSelection) {
      initialSelection.forEach((email) => {
        usersList.forEach((u) => {
          if (u.email === email) {
            u.isSelected = true;
            selected.push(u);
          }
        });
      });
    }

    setSelectedUsers(selected);
    setUserList(usersList);
    setAllUserList(usersList);
  }, [controller.state.teams, initialSelection]);

  const toggleSelection = (user) => {
    let selected = [];
    userList.forEach((u) => {
      u.isSelected = u.email == user.email ? !u.isSelected : u.isSelected;

      if (u.isSelected) selected.push(u);
    });

    setSelectedUsers(selected);
    setUserList([...userList]);
  };

  filterResults = ({ term }) => {
    let filtered = [...allUserList];

    if (term) {
      const pattern = Utils.getSearchPattern(term);

      filtered = filtered.filter((a) => {
        return a.name && a.name.match(pattern);
      });
    }

    setUserList(filtered);
  };

  goBack = () => {
    controller.goBack();
  };

  const onUsersSelected = () => {
    onSelectionDone(selectedUsers);
  };

  const userListUnique = UsersHelper.filterUniqueOtherUsers(
    controller,
    userList,
  );

  return (
    <View style={appStyles.container}>
      <KeyboardAvoidingView style={appStyles.kbViewNoFooter} behavior="height">
        <Header
          title="Share Element"
          subTitle="Who is this Element shared with?"
          hideAvatar
          goBack={goBack}
        />
        <View style={appStyles.preList} />
        <FlatList
          contentContainerStyle={{ paddingBottom: 100 }}
          style={[
            appStyles.scrollView,
            { backgroundColor: AppTheme.containerWhite, paddingHorizontal: 8 },
          ]}
          data={userListUnique}
          keyExtractor={(user) => user.email + user.isSelected}
          renderItem={({ item }) => (
            <ElementUser user={item} toggleSelection={toggleSelection} />
          )}
        />

        <View style={[appStyles.footerOptions]}>
          <ShareElementFabButton style={{ bottom: 100 }} />

          <Search
            showIcon={false}
            placeholder="Search users"
            filterResults={filterResults}
            style={{ marginBottom: 34 }}
            controller={this.controller}
          />

          <BottomButton
            buttonText={"Update"}
            style={{ paddingHorizontal: 16, height: 40 }}
            onPress={onUsersSelected}
            disabled={false}
          />
        </View>
      </KeyboardAvoidingView>
    </View>
  );
}
